import SummaryInfo from './summary-info';

export default SummaryInfo;
